import { Button } from '../../../components/Button';
import { logout } from '../../../utils/logout';
import { useTranslation } from 'react-i18next';

/**
 * ログアウトボタンコンポーネント
 * @returns ログアウトボタン
 */
export const Logout = () => {
    const { t } = useTranslation('settings');

    // ログアウト処理
    const handleLogout = async () => {
        // ログアウト処理
        await logout();
    };

    return (
        <div className="flex py-4">
            <Button variant="outline" className="w-full xl:w-1/2" onClick={handleLogout}>
                <span className="inline-block px-2 align-middle">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24px"
                        height="24px"
                        fill="currentColor"
                        className="bi bi-box-arrow-right"
                        viewBox="0 0 16 16"
                    >
                        <path
                            fillRule="evenodd"
                            d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"
                        />
                        <path
                            fillRule="evenodd"
                            d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"
                        />
                    </svg>
                </span>
                <span className="inline-block px-3 align-middle">{t('logout.button')}</span>
            </Button>
        </div>
    );
};

export default Logout;
